import { CircularProgress, Typography } from '@mui/material';
import { Row, Spacer } from '../../components';
import { Svgs } from '../../assets/svg';
import { OrganizationData } from '../../models/OrganizationData';
import { SearchResultCard } from './SearchResultCard';

export interface OrgSearchResultsProps {
  orgResults: OrganizationData[];
  orgSearchLoading: boolean;
  onViewOrg: (org: OrganizationData) => void;
  getSubtitle: (org: OrganizationData) => string;
}

export const OrgSearchResults: React.FC<OrgSearchResultsProps> = ({
  orgResults,
  orgSearchLoading,
  onViewOrg,
  getSubtitle,
}) => {
  if (orgSearchLoading) {
    return (
      <Row style={{ justifyContent: 'center', padding: '4px 0' }}>
        <CircularProgress size={28} />
      </Row>
    );
  }

  return (
    <>
      {orgResults.length > 0 && (
        <>
          <Typography variant='p16Light' color='secondary.dark' sx={{ lineHeight: 1 }}>
            Organizations
          </Typography>
          <Spacer height='xxs' />
          {orgResults.map((org, i) => (
            <SearchResultCard
              key={org.id}
              icon={<Svgs.IconOrgPaysLarge />}
              name={org.name ?? ''}
              subtitle={getSubtitle(org)}
              onView={() => onViewOrg(org)}
              isFirst={i === 0}
            />
          ))}
        </>
      )}
    </>
  );
};
